module.exports = __webpack_public_path__ + "static/assets/13a5967055d6a6e918998dbff00831f2.svg";